/**
 * Phase 14d-3 — AR aging admin read shapes.
 *
 * Per-facility breakdown of outstanding facility AR by aging bucket
 * (current / 1-30 / 31-60 / 60+ days past due). Backs the
 * `/admin/billing/ar-aging` page. Homecare invoices excluded (prepaid
 * via Stripe per Phase 10d — no overdue rail).
 */
import { z } from 'zod';
export const AdminArAgingFacilityRowSchema = z.object({
    facilityId: z.string().uuid(),
    facilityName: z.string(),
    /** Outstanding cents in the "not yet due" bucket. */
    current: z.number().int().nonnegative(),
    /** Outstanding cents in the 1-30 days past due bucket. */
    oneToThirty: z.number().int().nonnegative(),
    /** Outstanding cents in the 31-60 days past due bucket. */
    thirtyOneToSixty: z.number().int().nonnegative(),
    /** Outstanding cents in the >60 days past due bucket. */
    overSixty: z.number().int().nonnegative(),
    /** Sum of all four buckets for convenience. */
    totalOutstandingCents: z.number().int().nonnegative(),
    /** Number of open invoices contributing to the row. */
    invoiceCount: z.number().int().nonnegative(),
});
export const AdminArAgingResponseSchema = z.object({
    /** Aggregate totals across all facilities — same numbers as the
     *  dashboard `billing.ar_aging_summary` metric. */
    totals: z.object({
        current: z.number().int().nonnegative(),
        oneToThirty: z.number().int().nonnegative(),
        thirtyOneToSixty: z.number().int().nonnegative(),
        overSixty: z.number().int().nonnegative(),
        totalOutstandingCents: z.number().int().nonnegative(),
        invoiceCount: z.number().int().nonnegative(),
    }),
    /** One row per facility with open AR, sorted worst-aged first
     *  (60+ desc, then 31-60 desc, then total desc). */
    facilities: z.array(AdminArAgingFacilityRowSchema),
});
//# sourceMappingURL=ar-aging-admin.schema.js.map